<template>
  <div class="row button-container">
    <div class="col-3">
      <b-button
        @click="back()"
        class="back-button btn-ripple"
        variant="outline-light"
      >
        <img class="arrow" src="../../../../assets/arrow.svg" alt />
        {{ $tc("message.backAndNext", 1) }}
      </b-button>
    </div>
    <div class="col-6 text-center">
      <h2 class="store-title">{{ this.$store.state.storeName }}</h2>
    </div>
    <div class="col-3 text-right">
      <img
      v-if="infoCard==='yes'"
        id="my-trigger-button-id"
        class="alert-inf mr-2"
        v-b-tooltip.click.blur.left="$t('message.toolTipText', [getMinimumAmountRequired])"
        src="../../../../assets/alert.svg"
        alt
        tabindex="0"
      />
      <b-button
      v-if="nextBtn==='yes'"
        @click="next()"
        class="next-button btn-ripple next-button-color"
        variant="light"
        :disabled="disabled"
        >{{ $tc("message.backAndNext", 0) }}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["disabled", "info", "nextbtn", "isNextButtonActive"],
  name: "store-header",
   data: function () {
    return {
      infoCard: this.info,
      nextBtn: this.nextbtn
    };
  },
  methods: {
    back() {
        this.$emit('back')
      },
      next() {
        this.$emit('next')
      },
      
  },
  computed: {
    getMinimumAmountRequired () {
      return process.env.VUE_APP_MIN_AMOUNT_FOR_POINTS
    }
  }
};
</script>

<style lang="scss" scoped>
</style>